import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeys } from '@/hooks/queries/query-keys';
import { isAlreadyChangedError } from '@/lib/admin-action-error';
import { adminsApi } from '@/lib/api';

/**
 * Activate a suspended admin (POST /admins/:id/activate) — restores their
 * access. It is restorative, so the UI applies it directly without a confirm
 * step; the slot count is unchanged (the seat was always held). On success, and
 * on a 404/409 that means it already changed, we refetch the roster so the
 * Status badge reflects server truth (TDEV-140).
 */
export function useActivateAdmin() {
  const queryClient = useQueryClient();
  const refreshRoster = () =>
    void queryClient.invalidateQueries({ queryKey: queryKeys.admins.roster });
  return useMutation<{ id: string }, Error, string>({
    mutationFn: (adminId) => adminsApi.activateAdmin(adminId),
    onSuccess: refreshRoster,
    onError: (error) => {
      if (isAlreadyChangedError(error)) refreshRoster();
    },
  });
}
